export default __webpack_public_path__ + "static/media/feature-hitchhiker.5862bec4.png";